import { LOCALE } from 'src/dataLayer/env'
import { reportAuthFlowError } from 'src/dataLayer/remoteData/rollbar'

import { authenticatedGet } from '../shared/awsApiClientMethods'

export default () =>
  authenticatedGet({
    path: `v1.2.0/${LOCALE}/users/me`,
  })
    .then((response) => ({ authenticationToken: response.data.user.authentication_token }))
    .catch((error) => {
      reportAuthFlowError('sso:auth_token:request', error, { endpoint: 'users/me' })
      return { authenticationToken: null }
    })
